var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-row',[_c('m-col',{attrs:{"lg":"12"}},[_c('WebBuilderContainer',{ref:"container",staticClass:"builder-container",attrs:{"components":_vm.components,"max_width":"800px"},on:{"update-components":_vm.updateComponents}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }